<template>
  <div>
    <carousel :items-to-show="1.1" v-if="!loading">
      <slide v-model="slid" v-for="account in accountList" :key="account.id">
        <div>
          <bank-card
            :cardNumber="account.card_number"
            :bankAccountNumber="account.bank_account_number"
            @newAccount="createAccountHandler"
          >
          </bank-card>
        </div>
      </slide>

      <template #addons="{ currentSlide }">
        <navigation />
        <pagination />
        <div
          class="grid justify-items-center grid-cols-2 gap-2"
          v-if="accountList[currentSlide].card_number != 'new'"
          style="justify-items: center"
        >
          <button class="account-btn" @click="deleteHaandler(currentSlide)">
            حذف
          </button>
          <button
            class="account-btn"
            :class="{ accountbtnactive: accountList[currentSlide].is_default }"
            @click="makeMainHaandler"
          >
            پیش فرض
          </button>
          <button
            class="account-btn"
            @click="showChengeNameModalHaandler(currentSlide)"
          >
            نامگذاری
          </button>
          <button class="account-btn" @click="ditailsHaandler(currentSlide)">
            جزئیات
          </button>
        </div>
        <button v-else class="m-btn" @click="createAccountHandler">
          اتصال حساب جدید
        </button>
      </template>
    </carousel>

    <!-- <button class="m-btn" @click="createAccountHandler">
        اتصال حساب جدید
    </button> -->
    <Modal v-model="isShow" :close="closeModal">
      <div class="modal">
        <h4>اطلاعات حساب</h4>
        <div class="acc-data">
          <div class="acc-tile">تاریخ انقضای حساب</div>
          <div class="aac-option">
            {{ accountdata.payman_id.expiration_date }}
          </div>
        </div>
        <div class="acc-data">
          <div class="acc-tile">حداکثر تعداد برداشت روزانه</div>
          <div class="aac-option">
            {{ accountdata.usage.day_transaction_count }} /10
          </div>
        </div>

        <div class="acc-data">
          <div class="acc-tile">حداکثر تعداد برداشت ماهانه</div>
          <div class="aac-option">
            {{ accountdata.usage.month_transaction_count }} /250
          </div>
        </div>
        <div class="acc-data">
          <div class="acc-tile">حداکثر میزان برداشت در هر تراکنش(ریال)</div>
          <div class="aac-option">
            {{ accountdata.transaction_count }}
          </div>
        </div>
        <button class="m-btn" @click="closeModal">متوجه شدم</button>
      </div>
    </Modal>
    <Modal v-model="deleteMessageShow" :close="closeModal">
      <div class="modal">
        <h4>هشدار</h4>
        <p>
          شما درحال پاک کردن حساب خود می‌باشید . آیا از انجام این کار اطمینان
          دارید؟
        </p>
        <button class="m-btn" @click="closeModal">انصراف</button>
        <button
          class="m-btn"
          @click="deleteConferm"
          style="margin-top: 12px; background: #030135"
        >
          تایید
        </button>
      </div>
    </Modal>
    <Modal v-model="showChengeName" :close="closeModal">
      <div class="modal">
        <p>نام جدید حساب را وارد کنید:</p>
        <input style="width: 80%" v-model="newName" placeholder="نام جدید" />
        <button
          class="m-btn"
          @click="closeModal"
          style="width: 45%; direction: rtl"
        >
          انصراف
        </button>
        <button
          class="m-btn"
          @click="chenghNmaeHandler"
          style="
            margin-top: 12px;
            margin-left: 5px;
            background: #030135;
            width: 45%;
          "
        >
          تایید
        </button>
      </div>
    </Modal>
  </div>
</template>
<script>
import "vueperslides/dist/vueperslides.css";
import bankCard from "./BankCard.vue";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";

export default {
  components: { Carousel, Slide, Pagination, Navigation, bankCard },
  props: {
    accountList: [],
    loading: Boolean,
  },
  data() {
    return {
      accountCardList: [],
      slid: null,
      accountdata: {},
      isShow: false,
      deleteId: null,
      deleteMessageShow: false,
      showChengeName: false,
      chengeNameId: null,
      newName: null,
    };
  },
  computed: {
    // main(val){
    //     return this.accountList[val].is_default
    // }
  },
  mounted() {},
  methods: {
    // log(val) {
    //   console.log(val);
    // },
    createAccountHandler() {
      this.$router.push({ name: "AddAccounts" });
    },
    makeMainHaandler() {
      console.log(this.main);
    },
    deleteHaandler(i) {
      this.deleteId = this.accountList[i].id;
      this.deleteMessageShow = true;
    },
    showChengeNameModalHaandler(index) {
      this.showChengeName = true;
      this.chengeNameId = this.accountList[index].id;
    },
    chenghNmaeHandler() {
      const data = {
        updateData: {
          name: this.newName,
        },
        id: this.chengeNameId,
      };
      this.$store.dispatch("accounts/chengAccountName", data).then(() => {});
    },
    deleteConferm() {
      this.$store.dispatch("accounts/getAccount", this.deleteId).then(() => {
        this.deleteId = null;
      });
      this.deleteMessageShow = false;
    },
    ditailsHaandler(i) {
      this.isShow = true;
      this.accountdata = this.accountList[i];
      // this.$store.dispatch("accounts/getAccount",id).then(rsp =>{
      //   this.accountdata = rsp
      // })
      // },
    },
    closeModal() {
      this.showChengeName = false;
      this.isShow = false;
      this.deleteMessageShow = false;
      this.deleteId = null;
    },
  },
};
</script>
<style>
/* .carousel__track{
  justify-content: center;
} */
.carousel__slide {
  padding: 20px;
}
.carousel__next {
  display: none;
}
.carousel__prev {
  display: none;
}
.modal {
  width: 400px;
  padding: 30px;
  box-sizing: border-box;
  background-color: #fff;
  text-align: center;
}
.modal h4 {
  margin-bottom: 10px;
}
.modal p {
  margin-bottom: 24px;
}
.acc-data {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  font-family: fd-v;
  font-size: 15px;
  margin-bottom: 20px;
}
</style>
